module.exports = __webpack_public_path__ + "082e7027de2c30bf35964eb4f2fd0b68.svg";